import { defineComponent as _defineComponent } from 'vue'
import Modal from "@/components/ui/Modal.vue";
  import DropDown from "@/components/ui/dropdown/DropDown.vue";
  import Cleave from "vue-cleave-component";
  import { computed, onMounted, reactive, ref } from "vue";
  import {
    email,
    helpers,
    required,
    minLength,
    maxLength,
    numeric,
  } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import useVuelidate from "@vuelidate/core";
  import store from "@/store";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { useToast } from "vue-toastification";
  import getUserRole from "@/helpers/getUserRole";
  import { removeEmptyEntries } from "@/helpers/removeEmptyEntries";
  import { Business } from "@/types/BusinessInterface";
  import LeadSourceEnum from "@/enums/LeadSourceEnum";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CreateLeadModal',
  props: {
    isOpen: {
      required: true,
      type: Boolean,
    },
    listForUpdate: {
      required: true,
      type: Array,
    },
    lotId: {
      required: false,
      type: String,
      default: undefined,
    },
  },
  emits: ["close", "update"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const emits = __emit;
  const props = __props;
  const estateId = computed(() => store.state.user.selectedEstateId);
  const { isLandownerRole } = getUserRole();
  const loading = ref(false);
  const businessId = ref<string>("");
  const form = reactive({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    postcode: "",
    notes: "",
    watched: true,
  });
  const rules = computed(() => {
    return {
      firstName: { required, $autoDirty: true },
      email: { required, email },
      phone: {
        validPhoneNumber: form.phone
          ? helpers.withMessage("Invalid Phone", validPhoneNumber)
          : true,
      },
      postcode: { numeric, minLength: minLength(4) },
      notes: { minLength: minLength(3), maxLength: maxLength(1000) },
    };
  });
  const v$ = useVuelidate(rules, form);
  const emailError = ref("");

  onMounted(() => {
    getUserBusiness();
  });

  const getUserBusiness = () => {
    store
      .dispatch("business/getBusinessByLandownerId")
      .then((res) => {
        businessId.value = res.data._id;
      })
      .catch(() => {
        businessId.value = "";
      });
  };

  const save = async () => {
    v$.value.$touch();
    const isFormCorrect = await v$.value.$validate();

    if (!isFormCorrect) return;

    const data = {
      estateId: store.state.user.selectedEstateId,
      landownerId: isLandownerRole.value
        ? store.state.user.data._id
        : store.state.user.data.detailsId?.landownerId,
      businessId: businessId.value,
      source: LeadSourceEnum.MANUALLY,
      ...removeEmptyEntries(form),
      ...(props.lotId && { lotId: props.lotId }),
    };

    emailError.value = "";
    loading.value = true;
    store
      .dispatch("contact/createLead", data)
      .then((res) => {
        if (form.notes) {
          store
            .dispatch("userComments/addComment", {
              estateId: estateId.value,
              leadId: res.data._id,
              landownerId: isLandownerRole.value
                ? store.state.user.data._id
                : store.state.user.data.detailsId.landownerId,
              text: form.notes,
            })
            .then(() => {
              onSuccesfullCreate();
            });
        } else {
          onSuccesfullCreate();
        }
      })
      .catch((error) => {
        loading.value = false;

        if (error.response.data?.message?.includes("email")) {
          emailError.value = error.response.data.message;
          return;
        }

        toast.error("Something went wrong");
      });
  };

  function close() {
    emits("close");
    clearModal();
    v$.value.$reset();
  }
  function onSuccesfullCreate() {
    emits("update");
    close();
    loading.value = false;
  }
  const clearModal = () => {
    form.firstName = "";
    form.lastName = "";
    form.email = "";
    form.phone = "";
    form.notes = "";
    form.postcode = "";
    emailError.value = "";
  };

const __returned__ = { toast, emits, props, estateId, isLandownerRole, loading, businessId, form, rules, v$, emailError, getUserBusiness, save, close, onSuccesfullCreate, clearModal, Modal, DropDown, get Cleave() { return Cleave }, computed, onMounted, reactive, ref, get email() { return email }, get helpers() { return helpers }, get required() { return required }, get minLength() { return minLength }, get maxLength() { return maxLength }, get numeric() { return numeric }, get validPhoneNumber() { return validPhoneNumber }, get useVuelidate() { return useVuelidate }, get store() { return store }, get phoneNumberOption() { return phoneNumberOption }, get useToast() { return useToast }, get getUserRole() { return getUserRole }, get removeEmptyEntries() { return removeEmptyEntries }, get Business() { return Business }, get LeadSourceEnum() { return LeadSourceEnum } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})